<template>
    <div class="col-md-3 col-sm-6 mb-sm-4 profile-block profile-block--native new-style-native-advert" :class="{'outline-gold': isGoldSize, 'outline-regular': !isGoldSize, 'fromProfile': fromProfile}" :id="id">
        <span @click.prevent="advertClickUrl(advert, advert.isDefault ? '_self' : '_blank', 'native-solads')"
              class="profile-block-link h-100 cursor-pointer">
            <span class="profile-block-images loaded h-100">
                <div class="solad-girls-partner-tag" v-if="!hideExplicitRegionAds">{{ tagTitleText }}</div>
                <div v-if="!advert.imageurl" class="native-girls-image"></div>
                <div v-else :style="{'background-image': `url('${advert.imageurl}')`}" class="native-girls-image"></div>
            </span>
        </span>

        <span class="profile-block-details" v-if="advert.title || advert.description">
            <span class="user-details overflow-hidden">
                <span class="heading-1 d-flex">
                    <span class="text-ellipsis">
                        {{ advert.title }}
                    </span>
                </span>
                <span class="user-details-location">
                    <span class="text-ellipsis">
                        {{ advert.description }}
                    </span>
                </span>
            </span>
        </span>
    </div>
</template>

<script>
import xtrackingMixin from "@/components/mixins/xtrackingMixin";
import advertMixin from "@/components/mixins/adverts/advertMixin";
import {pick} from "lodash/object";
import {generateImpressionId} from "@/core/utils/helpers/advertHelper";
import {incrementNativeAdImpressionCount} from "@/core/utils/helpers/cookieHelper";

const data = () => {
    return {
        id: generateImpressionId(),
        impressionUrls: [],
    }
}

function observer() {
    if (this.hideExplicitRegionAds) {
        return;
    }

    const id = this.id;

    if (!id || typeof window === "undefined" || !_.get(this, 'advert.imageurl')) {
        return;
    }

    const advertisement = document.getElementById(id);

    if (typeof IntersectionObserver !== 'undefined') {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const impressionUrl = this.advert.impressionurl;
                    if (impressionUrl && !this.impressionUrls.includes(impressionUrl)) {
                        fetch(impressionUrl.replace('http://', 'https://'));
                        this.impressionUrls.push(impressionUrl);
                        const nativeImpressionCount = incrementNativeAdImpressionCount();
                        const extraAttributes = pick(this.advert['@attributes'] || {}, ['network', 'clickprice', 'campaign'])
                        const extraNormalizedAttributes = {image_full_link: this.advert.imageurl, text_line_1: this.advert.title, text_line_2: this.advert.description, tag_title: this.tagTitleText}
                        this.captureTrackingEvent(this.currentUser, (this.fromProfile ? 'profile' : 'search'), 'native-ads-impression', 'native-solads', null, {
                            position: this.advert.position,
                            sch: this.advert.searchId,
                            'native_impression_count': nativeImpressionCount,
                            ...extraAttributes,
                            ...extraNormalizedAttributes,
                        })
                    }
                    observer.disconnect();
                }
            });
        }, {
            threshold: 0.5
        });

        observer.observe(advertisement);
    }
}

function isGoldSize() {
    return _.get(this, 'advert.advertSize', '').includes('gold');
}

export default {
    data,
    computed: {
        ...mapState(['currentUser','hideExplicitRegionAds']),
        tagTitleText() {
            return _.get(this, 'advert.tag_title', 'Anzeige');
        },
        isGoldSize,
    },
    mixins: [xtrackingMixin, advertMixin],
    props: {
        advert: {
            required: true,
        },
        fromProfile: {
            type: Boolean,
            required: false,
            default: () => false
        },
    },
    watch: {
        advert: {
            deep: true,
            handler() {
                this.observer()
            }
        },
    },
    methods: {
        observer,
    }
}
</script>
